var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-box",class:{ button: _vm.button, low: _vm.low }},[_c('div',{staticClass:"circle-border"},[_c('div',{staticClass:"circle-core",style:({backgroundColor: _vm.backgroundColor})})])])}
var staticRenderFns = []

export { render, staticRenderFns }